/**
 * @generated SignedSource<<7343341b515a44b829f6f300ca989616>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServicesTable_items$data = ReadonlyArray<{
  readonly isService: boolean;
  readonly price: number;
  readonly " $fragmentSpreads": FragmentRefs<"OrderServiceRow_orderService">;
  readonly " $fragmentType": "ServicesTable_items";
}>;
export type ServicesTable_items$key = ReadonlyArray<{
  readonly " $data"?: ServicesTable_items$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServicesTable_items">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ServicesTable_items",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isService",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderServiceRow_orderService"
    }
  ],
  "type": "OrderItem",
  "abstractKey": null
};

(node as any).hash = "bbb61bab17866bc65e747d45577eeeeb";

export default node;
